import { useEffect } from 'react';

import { useToastStore } from '../shared/stores/toastStore';

export const useNetworkStatus = () => {
  const { addToast, resetToasts } = useToastStore();

  useEffect(() => {
    window.addEventListener('load', () => {
      window.addEventListener('online', () => {
        resetToasts(true);
      });
      window.addEventListener('offline', () => {
        addToast({
          severity: 'warning',
          message: 'Looks like you are offline. Some actions may not work.',
          showCloseButton: false,
          sticky: true,
          autoHideDuration: null,
        });
      });
    });
  }, []);
};
